<script setup lang="ts">
import { useKanbanLog } from '@entities/kanban-comment'
import { CardAdmin } from '@shared/ui/cards'

import { useTutorKanbanStore } from '../model/store'
import TutorKanbanLogItem from './kanban-log/TutorKanbanLogItem.vue'

defineOptions({
  name: 'TutorKanbanLog',
})

const tutorKanbanStore = useTutorKanbanStore()

const { isMainLog, isLastLog } = useKanbanLog()
</script>

<template>
  <CardAdmin title="Changelog">
    <TutorKanbanLogItem
      v-for="(log, index) in tutorKanbanStore.getLogs"
      :key="log.id"
      :log="log"
      :main="isMainLog(log, index, tutorKanbanStore.getLogs)"
      :last="isLastLog(log, index, tutorKanbanStore.getLogs)"
    />
  </CardAdmin>
</template>

<style scoped lang="scss" src="./TutorKanbanLog.scss" />
